(function() {
  function initFeaturedCollectionAutoplay(sectionId) {
    var sliders = document.querySelectorAll('slider-component');
    var targetSlider = null;
    for (var i = 0; i < sliders.length; i++) {
      if (sliders[i].querySelector('#Slider-' + sectionId)) {
        targetSlider = sliders[i];
        break;
      }
    }
    if (!targetSlider) return;

    var nextBtn = targetSlider.querySelector('.slider-button--next');
    var prevBtn = targetSlider.querySelector('.slider-button--prev');
    if (!nextBtn) return;

    var interval = null;
    var resumeTimeout = null;
    var AUTOPLAY_DELAY = 4000;
    var RESUME_DELAY = 2000;

    function goNext() {
      if (nextBtn && !nextBtn.hasAttribute('disabled')) {
        nextBtn.click();
      } else {
        var sliderList = targetSlider.querySelector('#Slider-' + sectionId);
        if (sliderList) {
          sliderList.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    function startAutoplay() {
      if (interval) return;
      interval = setInterval(goNext, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function pauseAndResume() {
      stopAutoplay();
      if (resumeTimeout) clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(startAutoplay, RESUME_DELAY);
    }

    targetSlider.addEventListener('mouseenter', function() {
      stopAutoplay();
      if (resumeTimeout) clearTimeout(resumeTimeout);
    });

    targetSlider.addEventListener('mouseleave', function() {
      startAutoplay();
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', pauseAndResume, true);
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', pauseAndResume, true);
    }

    startAutoplay();
  }

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('[data-featured-collection-autoplay]');
    for (var i = 0; i < sections.length; i++) {
      initFeaturedCollectionAutoplay(sections[i].getAttribute('data-featured-collection-autoplay'));
    }
  });
})();
